import { postResource } from "services";

export function searchInLandingPage(lang, searchInput, onSuccess, onFail) {
	const path = `api/search?lang=${lang}`;
	const data = {
		search: searchInput,
	};
	postResource(path, data, onSuccess, onFail);
}
